/* eslint-disable react/no-array-index-key */
/** @jsx jsx */
import { jsx, Button, Flex, Input } from "theme-ui";
import { useState } from "react";
import PropTypes from "prop-types";

// Different Layouts
// variant 1 -- buttons
// variant 2 -- amount_and_button
// variant 3 -- buttons_with_other

const AmountSelectorsWithAmount = ({
  layoutProps = {},
  updateAmount,
  showDonations,
  rate = 1,
  classname = "",
}) => {
  const {
    btnStyle = {},
    btnText = "Donate Now",
    inputStyle = {},
    initialInput = "",
  } = layoutProps;
  const [amount, setAmount] = useState(initialInput || "");
  return (
    <Flex>
      <Input
        sx={inputStyle}
        name="amount"
        value={`${amount}`}
        onChange={(e) => {
          const x = e.target.value.replace(/^\D+/g, "");
          setAmount(x ? parseInt(x, 10) : "");
        }}
      />
      <Button
        sx={{ padding: "10px", ...btnStyle }}
        className={classname}
        onClick={() => {
          updateAmount(amount * rate);
          showDonations();
        }}
      >
        {btnText}
      </Button>
    </Flex>
  );
};
AmountSelectorsWithAmount.propTypes = {
  layoutProps: PropTypes.shape({}),
  updateAmount: PropTypes.func.isRequired,
  showDonations: PropTypes.func.isRequired,
  rate: PropTypes.number,
  classname: PropTypes.string,
};
AmountSelectorsWithAmount.defaultProps = {
  layoutProps: {},
  classname: "",
  rate: 1,
};

const AmountSelectorsForObjects = ({
  layoutProps = {},
  updateAmount,
  showDonations,
  classname = "",
}) => {
  const {
    btnStyle = {},
    buttons = [],
    showOther = false,
    rate = 1,
    item = "Trees",
    inputStyle = {},
    layoutStyle = { display: "flex", padding: "8px" },
  } = layoutProps;
  return (
    <div>
      <div style={layoutStyle}>
        {buttons.map((b) => {
          const { text, qty = 0 } = b;
          return (
            <Button
              // key={bidx}
              sx={btnStyle}
              className={classname}
              onClick={() => {
                updateAmount(qty * rate);
                showDonations();
              }}
            >
              {text || `${qty} ${item}`}
            </Button>
          );
        })}
      </div>

      {showOther && (
        <div sx={{ mt: buttons.length > 0 ? 3 : 0 }}>
          <AmountSelectorsWithAmount
            layoutProps={{ btnStyle, btnText: showOther, inputStyle }}
            updateAmount={updateAmount}
            showDonations={showDonations}
            rate={rate}
            classname={classname}
          />
        </div>
      )}
    </div>
  );
};
AmountSelectorsForObjects.propTypes = {
  layoutProps: PropTypes.shape({}),
  updateAmount: PropTypes.func.isRequired,
  showDonations: PropTypes.func.isRequired,
  classname: PropTypes.string,
};
AmountSelectorsForObjects.defaultProps = {
  layoutProps: {},
  classname: "",
};

// eslint-disable-next-line import/prefer-default-export
export const AmountSelectors = (props) => {
  const { layout, showDonations, classname } = props;
  switch (layout) {
    case "amount_and_button":
      return <AmountSelectorsWithAmount {...props} />;
    case "buttons":
      return <AmountSelectorsForObjects {...props} />;

    default:
      return (
        <Button
          sx={{ color: "white", bg: "red", "&:hover": { bg: "darkred" } }}
          className={classname}
          onClick={showDonations}
        >
          {" "}
          Donate Now{" "}
        </Button>
      );
  }
};
AmountSelectors.propTypes = {
  layout: PropTypes.string.isRequired,
  showDonations: PropTypes.func.isRequired,
  classname: PropTypes.string,
};
AmountSelectors.defaultProps = {
  classname: "",
};
